import { Plus } from 'lucide-react';
import React from 'react';
import type { SenderProfile } from '../../../lib/api';
import { SenderProfileEditRow } from './SenderProfileEditRow';
import { SenderProfileReadRow } from './SenderProfileReadRow';
import styles from './sender-profiles.module.css';

interface SenderProfilesProps {
  profiles: SenderProfile[];
  schemaProperties: string[];
  isEditing: boolean;
  onAdd: () => void;
  onUpdate: (
    profileId: string,
    field: 'label' | 'nameFieldPath' | 'emailFieldPath',
    value: string,
  ) => void;
  onRemove: (profileId: string) => void;
}

export const SenderProfiles: React.FC<SenderProfilesProps> = ({
  profiles,
  schemaProperties,
  isEditing,
  onAdd,
  onUpdate,
  onRemove,
}) => {
  const hasProfiles = profiles.length > 0;

  return (
    <section className={styles.senderProfiles}>
      <header>
        <h6>Sender profiles</h6>
        <p>
          Named sender profiles that map a label to a pair of partner-resource field paths (name, email).
          Tenants choose one per template at send time.
        </p>
        {isEditing && (
          <button type="button" onClick={onAdd}>
            <Plus />
            Add profile
          </button>
        )}
      </header>

      {!hasProfiles ? (
        <p>No profiles defined.</p>
      ) : (
        <ul>
          {profiles.map(profile =>
            isEditing ? (
              <SenderProfileEditRow
                key={profile.profileId}
                profile={profile}
                schemaProperties={schemaProperties}
                onUpdate={onUpdate}
                onRemove={onRemove}
              />
            ) : (
              <SenderProfileReadRow key={profile.profileId} profile={profile} />
            ),
          )}
        </ul>
      )}
    </section>
  );
};
